const t = {
  topLeft: {
    placement: "topLeft",
    direction: "col"
  },
  topCenter: {
    placement: "top",
    direction: "col"
  },
  topRight: {
    placement: "topRight",
    direction: "col"
  },
  bottomLeft: {
    placement: "bottomLeft",
    direction: "col"
  },
  bottomCenter: {
    placement: "bottom",
    direction: "col"
  },
  bottomRight: {
    placement: "bottomRight",
    direction: "col"
  },
  leftTop: {
    placement: "leftTop",
    direction: "row"
  },
  leftCenter: {
    placement: "left",
    direction: "row"
  },
  leftBottom: {
    placement: "leftBottom",
    direction: "row"
  },
  rightTop: {
    placement: "rightTop",
    direction: "row"
  },
  rightCenter: {
    placement: "right",
    direction: "row"
  },
  rightBottom: {
    placement: "rightBottom",
    direction: "row"
  }
}, e = {
  placement: "topCenter",
  trigger: "hover",
  type: "normal"
};
export {
  e as defaultReoBallonProps,
  t as rcToolTipPlacementMap
};
//# sourceMappingURL=const.mjs.map
